module.exports = __webpack_public_path__ + "img/DIGI83866.5da03e78.png";